import React, { forwardRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import A4GridLayout from './A4GridLayout';
import ContentPage from './ContentPage';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import { DeleteIcon, DuplicateIcon } from '../../../../bombiix-icon';

export function PageContainer({ pageId, page, index, handleDuplicatePage, handlePageDelete, handleTitleChange, totalPages, ...props }, ref) {
  const { t } = useTranslation('common');
  const [state, setState] = useState({
    deleteModal: false,
  });

  const confirmPageDelete = () => {
    setState((prevState) => ({
      ...prevState,
      deleteModal: true,
    }));
  };

  const closeDeleteModal = () => {
    setState((prevState) => ({
      ...prevState,
      deleteModal: false,
    }));
  };
  return (
    <div>
      <div className="page-title-container">
        <input
          type="text"
          placeholder={t('CUSTOM_MODULE.ENTER_PAGE_TITLE')}
          onChange={(e) => handleTitleChange(e.target.value, index)}
          value={page.pageTitle}
        />
        <div className="ml-auto">
          {!page?.isContectPage && (
            <button
              aria-label="Copy"
              title={t('CUSTOM_MODULE.DUPLICATE_PAGE')}
              type="button"
              className="btn btn-border py-0 px-1"
              onClick={() => handleDuplicatePage(index)}
            >
              <DuplicateIcon size={24} />
            </button>
          )}

          <button type="submit" title={t('CUSTOM_MODULE.DELETE_PAGE')} disabled={totalPages <= 1} onClick={() => confirmPageDelete()} className="btn px-0 ">
            <span className="sr-only">{t('CUSTOM_MODULE.DELETE_PAGE')}</span>
            <DeleteIcon size={24} />
          </button>
        </div>
      </div>
      {!page?.isContectPage ? (
        <A4GridLayout pageId={pageId} pageGrid={page?.grid} pageIndex={index} ref={ref} {...props} />
      ) : (
        <div className="a4-grid-layout content-page p-2">
          <ContentPage headingData={page?.contentTable} />
        </div>
      )}
      {state.deleteModal && (
        <ConfirmationPopup
          onOpen={state.deleteModal}
          onConfirm={() => handlePageDelete(index)}
          title={t('CUSTOM_MODULE.DELETE_MODAL_TITLE')}
          message={t('CUSTOM_MODULE.DELETE_MODAL_MSG1')}
          secondMessage={t('CUSTOM_MODULE.DELETE_MODAL_MSG2')}
          toggle={() => closeDeleteModal()}
        />
      )}
    </div>
  );
}
const LibraryPages = forwardRef(PageContainer);
export default React.memo(LibraryPages);
